// React libraries
import * as React from 'react';
// Custom Styles
import { useStyles } from "./WhiteContentBarButtonStyles";
// Material-UI Core
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
export const WhiteContentBarButton = (props) => {
    const classes = useStyles(props);
    const { onClick, data, backgroundColor } = props;
    const [leftContent, setLeftContent] = React.useState(data.leftContent);
    const [rightContent, setRightContent] = React.useState(data.rightContent);
    let tempBackgroundColor;
    if (backgroundColor === "white") {
        tempBackgroundColor = "#ffffff";
    }
    else {
        tempBackgroundColor = "#f5f5f5";
    }
    React.useEffect(() => {
        if (data.rightContent === "") {
            setLeftContent(data.leftContent);
        }
        else {
            setLeftContent(data.leftContentWithRightContent);
        }
        setRightContent(data.rightContent);
    }, [data.rightContent]);
    return (React.createElement(Button, { onClick: onClick, style: {
            backgroundColor: tempBackgroundColor,
        }, className: classes.whiteContentBarButton },
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { className: classes.leftContent, item: true, md: 6 }, leftContent),
            React.createElement(Grid, { className: classes.rightContent, item: true, md: 6 }, rightContent))));
};
WhiteContentBarButton.defaultProps = {
    backgroundColor: "white",
};
export default React.memo(WhiteContentBarButton);
